import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ThemeService } from '../../services/theme.service';
import { DefaultFooterComponent } from '../default-footer/default-footer.component';
import { DefaultHeaderComponent } from '../default-header/default-header.component';
import { DefaultSidebarComponent } from '../default-sidebar/default-sidebar.component';

/** Application shell: sidebar + header + routed page + footer. */
@Component({
  selector: 'app-default-body',
  imports: [RouterOutlet, DefaultSidebarComponent, DefaultHeaderComponent, DefaultFooterComponent],
  templateUrl: './default-body.component.html',
  styleUrl: './default-body.component.scss',
})
export class DefaultBodyComponent {
  protected readonly theme = inject(ThemeService);

  constructor() {
    inject(Router)
      .events.pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(inject(DestroyRef)),
      )
      .subscribe(() => this.theme.mobileSidebarOpen.set(false));
  }
}
